import React, { useEffect, useState } from "react";
import axios from "axios";
import { Table, Button, Popconfirm, message, Form, Row, Col } from "antd";
import { EditOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import "../index.css";
import { API_URL } from "../../config";
import CommonModal from "../common/commonModal/CommonModal";
import AntDesignTable from "../common/antTable/AntDesignTable";
import KioskForm from "./KioskForm";

const KiosksContainer = () => {
  const [kiosks, setKiosks] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentKiosk, setCurrentKiosk] = useState([]);
  const [form] = Form.useForm();

  useEffect(() => {
    fetchKiosks();
  }, []);

  const fetchKiosks = async () => {
    try {
      const response = await axios.get(`${API_URL}/kiosk/?skip=0&limit=100`);
      setKiosks(response.data);
    } catch (error) {
      console.error("There was an error fetching the kiosk data!", error);
    }
  };

  const fetchKioskDetails = async (kiosk_id) => {
    try {
      const response = await axios.get(`${API_URL}/kiosk/${kiosk_id}`);
      setCurrentKiosk(response.data);
      form.setFieldsValue(response.data);
    } catch (error) {
      console.error("There was an error fetching the kiosk details!", error);
    }
  };

  const handleEdit = async (record) => {
    await fetchKioskDetails(record.kiosk_id);
    setIsModalVisible(true);
  };

  const handleDelete = async (kiosk_id) => {
    try {
      await axios.delete(`${API_URL}/kiosk/${kiosk_id}`);
      message.success("Kiosk deleted successfully");
      fetchKiosks();
    } catch (error) {
      console.error("There was an error deleting the kiosk data!", error);
      message.error("Failed to delete the kiosk");
    }
  };

  const handleOk = async () => {
    try {
      await form.validateFields();
      const formData = form.getFieldsValue();
      if (currentKiosk && currentKiosk.kiosk_id) {
        await axios.patch(`${API_URL}/kiosk/${currentKiosk.kiosk_id}`, formData, {
          headers: {
            "Content-Type": "application/json; charset=utf-8",
          },
        });
        message.success("Kiosk updated successfully");
      } else {
        await axios.post(`${API_URL}/kiosk/`, formData, {
          headers: {
            "Content-Type": "application/json; charset=utf-8",
          },
        });

        message.success("Kiosk created successfully");
      }

      setIsModalVisible(false);
      fetchKiosks();
    } catch (error) {
      console.error("Error occurred:", error);

      if (error.response?.data?.detail) {
        const detail = error.response.data.detail;
        const kioskMessage =
          typeof detail === "string"
            ? detail.includes("::")
              ? detail.split("::")[1]
              : detail
            : "An error occurred.";
        message.error(kioskMessage);
      } else {
        message.error("An error occurred while submitting the form.");
      }
    }
  };


  const handleCreate = () => {
    form.resetFields();
    setCurrentKiosk(null);
    setIsModalVisible(true);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const columns = [
    {
      title: "Kiosk ID",
      dataIndex: "kiosk_id",
      key: "kiosk_id",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Open Time",
      dataIndex: "open_time",
      key: "open_time",
    },
    {
      title: "Address 1",
      dataIndex: "address_1",
      key: "address_1",
    },
    {
      title: "Country",
      dataIndex: "country",
      key: "country",
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <span>
          <Row gutter={[8, 8]}>
            <Col xs={12} sm={8} md={6}>
              <Button
                className="edit-button"
                icon={<EditOutlined />}
                onClick={() => handleEdit(record)}
              />
            </Col>
            <Col xs={12} sm={8} md={6}>
              <Popconfirm
                title="Are you sure you want to delete this kiosk?"
                onConfirm={() => handleDelete(record.kiosk_id)}
                okText="Yes"
                cancelText="No"
              >
                <Button
                  className="delete-button"
                  icon={<DeleteOutlined />}
                  style={{ marginLeft: 8 }}
                />
              </Popconfirm>
            </Col>
          </Row>
        </span>
      ),
    },
  ];

  return (
    <>
      <Button type="primary" icon={<PlusOutlined />} onClick={handleCreate}>
        Create New Kiosk
      </Button>

      <AntDesignTable columns={columns} tableData={kiosks} />
      <CommonModal
        title={currentKiosk ? "Edit Kiosk" : "Create Kiosk"}
        visible={isModalVisible}
        onCancel={handleCancel}
        onConfirm={handleOk}
        confirmButtonText="Save"
      >
        <KioskForm form={form} initialValues={currentKiosk} />
      </CommonModal>
    </>
  );
};

export default KiosksContainer;
